import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle as faCircleEmpty } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

const propTypes = {
  canBeApportioned: PropTypes.bool,
};

const defaultProps = {
  canBeApportioned: false,
};

function ApportionableStatus({ canBeApportioned }) {
  const icon = canBeApportioned ? faCircle : faCircleEmpty;
  const color = canBeApportioned ? 'var(--accessible-green)' : 'var(--black)';
  const opacity = canBeApportioned ? '1' : '0.5';
  const labelModifier = canBeApportioned ? 'can' : 'cannot';
  const label = `This data ${labelModifier} be apportioned to custom geographies`;
  return (
    <>
      <FontAwesomeIcon icon={icon} style={{ color, opacity, marginRight: 'var(--spacer-2)' }} />
      {label}
    </>
  );
}

ApportionableStatus.propTypes = propTypes;
ApportionableStatus.defaultProps = defaultProps;

export default ApportionableStatus;
